(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frooji-reviews"] && !Shopify.designMode) return;
  try {
    
  const markClickedTikTok = () => {
    const frame = document.activeElement;
    if (!frame?.matches('.frj-review__tiktok iframe')) return false;
    frame.parentElement.setAttribute('playing', '');
    frame.blur();
    return true;
  };

  window.addEventListener('blur', () => {
    if (!markClickedTikTok()) setTimeout(markClickedTikTok);
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://www.tiktok.com') return;
    let data = event.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch {
        return;
      }
    }
    if (!data || data.type !== 'onStateChange') return;
    const frame = [...document.querySelectorAll('.frj-review__tiktok iframe')].find(
      (iframe) => iframe.contentWindow === event.source
    );
    frame?.parentElement.toggleAttribute('playing', data.value === 1 || data.value === 3);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
